/*
 * @Author: mmmggs
 * @Date: 2020-12-10 15:50:30
 * @LastEditors: mmmggs
 * @LastEditTime: 2020-12-11 15:38:48
 * @FilePath: \wonderkang\src\router\index.js
 * @Description: 
 */
import { createRouter, createWebHashHistory } from "vue-router";
// import Home from "../views/Home.vue";
import ErrorPage from '../views/404.vue'
import WanShe from '../views/WanShe.vue'

const routes = [
//   {
//     path: "/",
//     name: "404",
//     component: ErrorPage
//   },
  {
    path: "/",
    name: "WanShe",
    component: WanShe
  },
];

const router = createRouter({
  history: createWebHashHistory(),
  routes
});

export default router;
